import React from 'react';
import { Link } from 'react-router-dom';

function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg p-8">
          <Link to="/" className="text-primary hover:text-secondary mb-4 inline-block">
            ← Back to Home
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms and Conditions for KOVA</h1>
          
          <div className="prose max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mt-6">1. Introduction</h2>
            <p className="text-gray-600 mt-2">
              1.1. These Terms and Conditions govern the use of KOVA, a Ghanian based e-commerce platform with a secure payment holding service.
            </p>
            <p className="text-gray-600 mt-2">
              1.2. By accessing, browsing, or shopping on this platform, you agree to all the terms and conditions in this agreement.
            </p>
            <p className="text-gray-600 mt-2">
              1.3. KOVA Ghana Limited reserves the right to modify these terms with reasonable notice to users.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">2. Definitions</h2>
            <p className="text-gray-600 mt-2">
              2.1. "Platform" refers to KOVA.
            </p>
            <p className="text-gray-600 mt-2">
              2.2. "User" refers to buyers and sellers on the platform.
            </p>
            <p className="text-gray-600 mt-2">
              2.3. "Secure Payment Holding" refers to our service where we temporarily hold the buyer's payment until the transaction is completed satisfactorily.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">3. Account Registration and Security</h2>
            <p className="text-gray-600 mt-2">
              3.1. Users must provide accurate, current, and complete information during registration.
            </p>
            <p className="text-gray-600 mt-2">
              3.2. Users are responsible for maintaining the confidentiality of their account credentials.
            </p>
            <p className="text-gray-600 mt-2">
              3.3. Multiple accounts per user are prohibited unless explicitly authorized.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">4. Secure Payment Holding Service and Payment Protection</h2>
            <p className="text-gray-600 mt-2">
              4.1. All payments are processed through our secure payment holding service.
            </p>
            <p className="text-gray-600 mt-2">
              4.2. How it works:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>When a buyer makes a purchase, we hold the payment securely.</li>
              <li>The seller is notified to ship the item.</li>
              <li>Once the buyer receives and approves the item, we release the payment to the seller.</li>
            </ul>
            <p className="text-gray-600 mt-2">
              4.3. This service protects both buyers and sellers by ensuring that payment is only released when both parties are satisfied.
            </p>
            <p className="text-gray-600 mt-2">
              4.4. The platform supports transactions in Ghana.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">5. Seller Obligations</h2>
            <p className="text-gray-600 mt-2">
              5.1. Sellers must maintain performance standards set by the platform.
            </p>
            <p className="text-gray-600 mt-2">
              5.2. Accurate product listings and descriptions are mandatory.
            </p>
            <p className="text-gray-600 mt-2">
              5.3. Sellers must complete a mandatory education program on platform standards.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">6. Buyer Protection</h2>
            <p className="text-gray-600 mt-2">
              6.1. On-time Delivery Guarantee: Platform credit may be issued for late deliveries.
            </p>
            <p className="text-gray-600 mt-2">
              6.2. Product Quality Protection: Refunds available for defective, false or damaged products.
            </p>
            <p className="text-gray-600 mt-2">
              6.3. 30-day Refund Policy: Buyers can claim refunds within 7 days of delivery if products don't meet agreed terms.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">7. Prohibited Activities</h2>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>Diverting customers away from the platform is strictly prohibited.</li>
              <li>Manipulation of search results, customer reviews, or ratings is forbidden.</li>
              <li>Creating duplicate or misleading listings is not allowed.</li>
              <li>Using the platform for illegal activities is prohibited.</li>
              <li>Posting abusive or offensive content is not permitted.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">8. Dispute Resolution</h2>
            <p className="text-gray-600 mt-2">
              8.1. The platform will mediate disputes between buyers and sellers.
            </p>
            <p className="text-gray-600 mt-2">
              8.2. A clear timeline for dispute resolution will be provided for each case.
            </p>
            <p className="text-gray-600 mt-2">
              8.3. Users agree to cooperate fully in the dispute resolution process.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">9. Fees and Expenses</h2>
            <p className="text-gray-600 mt-2">
              9.1. [Details of fee structure here]
            </p>
            <p className="text-gray-600 mt-2">
              9.2. Fees will be deducted from the transaction amount before release to the seller.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">10. Shipping and Delivery</h2>
            <p className="text-gray-600 mt-2">
              10.1. Sellers are responsible for complying with all applicable shipping regulations.
            </p>
            <p className="text-gray-600 mt-2">
              10.2. Cross-border shipping within West Africa must adhere to relevant customs and import/export laws.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">11. Identity Verification</h2>
            <p className="text-gray-600 mt-2">
              11.1. All users must complete a verification process as specified by the platform.
            </p>
            <p className="text-gray-600 mt-2">
              11.2. The platform reserves the right to refuse service to unverified users.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">12. Mobile Money and Payment Options</h2>
            <p className="text-gray-600 mt-2">
              12.1. The platform integrates with all types of mobile money in Ghana.
            </p>
            <p className="text-gray-600 mt-2">
              12.2. Offline support and cash-on-delivery options are available in select areas.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">13. Data Protection and Privacy</h2>
            <p className="text-gray-600 mt-2">
              13.1. User data is protected in compliance with the relevant African data protection laws
            </p>
            <p className="text-gray-600 mt-2">
              13.2. The platform's privacy policy details how user data is collected, used, and protected.
            </p>
            <p className="text-gray-600 mt-2">
              13.3. Users agree to the collection and use of information as described in our Privacy Policy below 
            </p>
            <p className="text-gray-600 mt-2">
              Data Protection and Privacy
            </p>
            <p className="text-gray-600 mt-2">
              13.3. We collect and use personal information for the following purposes:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>To process transactions and provide our services</li>
              <li>To communicate with users about their accounts and orders</li>
              <li>To improve our platform and user experience</li>
              <li>To prevent fraud and enhance security</li>
            </ul>
            <p className="text-gray-600 mt-2">
              13.4. We do not sell or rent personal information to third parties.
            </p>
            <p className="text-gray-600 mt-2">
              13.5. Users have the right to access, correct, or delete their personal information.
            </p>
            <p className="text-gray-600 mt-2">
              13.6. We use industry-standard security measures to protect user data.
            </p>
            <p className="text-gray-600 mt-2">
              13.7. By using our platform, users consent to the collection and use of their information as described in these terms.
            </p>
            <p className="text-gray-600 mt-2">
              13.8. For more detailed information about our privacy practices, users can contact our customer support
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">14. Language and Support</h2>
            <p className="text-gray-600 mt-2">
              14.1. The platform is offered in English.
            </p>
            <p className="text-gray-600 mt-2">
              14.2. Customer support is available in these languages during specified hours.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">15. Seasonal Considerations</h2>
            <p className="text-gray-600 mt-2">
              15.1. The platform may adjust delivery estimates during challenging weather seasons.
            </p>
            <p className="text-gray-600 mt-2">
              15.2. Users will be notified of any seasonal changes affecting services.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">16. Community Standards</h2>
            <p className="text-gray-600 mt-2">
              16.1. Users must respect local cultural norms and practices in all transactions.
            </p>
            <p className="text-gray-600 mt-2">
              16.2. Content that violates community standards will be removed.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">17. Fraud Prevention</h2>
            <p className="text-gray-600 mt-2">
              17.1. The platform employs advanced fraud detection measures.
            </p>
            <p className="text-gray-600 mt-2">
              17.2. Users must cooperate with fraud prevention processes as required.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">18. Intellectual Property</h2>
            <p className="text-gray-600 mt-2">
              18.1. All content on the platform, including logos, designs, and software, is the property of KOVA company LTD.
            </p>
            <p className="text-gray-600 mt-2">
              18.2. Users may not use, reproduce, or distribute our intellectual property without permission.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">19. Limitation of Liability</h2>
            <p className="text-gray-600 mt-2">
              19.1. KOVA is not responsible for damages incurred after the transaction or because of using the platform.
            </p>
            <p className="text-gray-600 mt-2">
              19.2. We are not liable for issues arising from third-party links on our platform.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">20. Termination of Service</h2>
            <p className="text-gray-600 mt-2">
              20.1. The platform may terminate or suspend service to users who violate these terms.
            </p>
            <p className="text-gray-600 mt-2">
              20.2. Users may terminate their account at any time, subject to ongoing transaction commitments.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">21. Product Listings and Inventory</h2>
            <p className="text-gray-600 mt-2">
              21.1. Sellers must provide accurate and detailed product information.
            </p>
            <p className="text-gray-600 mt-2">
              21.2. Creating duplicate or misleading listings is prohibited.
            </p>
            <p className="text-gray-600 mt-2">
              21.3. Sellers are responsible for maintaining accurate inventory levels.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">23. Order Fulfillment and Shipping</h2>
            <p className="text-gray-600 mt-2">
              23.1. The platform will hold and fulfill orders for small, fast-moving items from our warehouse.
            </p>
            <p className="text-gray-600 mt-2">
              23.2. Sellers must ship products within the timeframe specified by the platform for items not held in our warehouse.
            </p>
            <p className="text-gray-600 mt-2">
              23.3. Shipping must occur within 1 business days.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">24. Packaging Requirements</h2>
            <p className="text-gray-600 mt-2">
              24.1. Items must be packaged securely to prevent damage during shipping.
            </p>
            <p className="text-gray-600 mt-2">
              24.3. Clear labelling may be used for proper identification.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">25. Communication and Customer Service</h2>
            <p className="text-gray-600 mt-2">
              25.1. All communication with buyers must be through the platform's messaging system.
            </p>
            <p className="text-gray-600 mt-2">
              25.2. Sellers cannot send unsolicited marketing emails to customers.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">26. Fulfillment Operations</h2>
            <p className="text-gray-600 mt-2">
              26.1. The platform reserves the right to store and fulfill orders for eligible small, fast-moving items from our own warehouses to ensure efficient delivery.
            </p>
            <p className="text-gray-600 mt-2">
              26.2. Sellers agree that the platform may hold and manage inventory for eligible products at its discretion.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">27. User Responsibilities</h2>
            <p className="text-gray-600 mt-2">
              27.1. Users are expected to conduct themselves with respect and honesty in all platform interactions.
            </p>
            <p className="text-gray-600 mt-2">
              27.2. Users are responsible for maintaining the security of their account and for all activities that occur under their account.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">28. Amendments to Terms</h2>
            <p className="text-gray-600 mt-2">
              28.1. Users will be notified of any changes to these Terms and Conditions via email and/or app notifications.
            </p>
            <p className="text-gray-600 mt-2">
              28.2. Continued use of the platform after such notifications constitutes acceptance of the updated terms.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">29. Force Majeure</h2>
            <p className="text-gray-600 mt-2">
              29.1. Neither party shall be liable for failure to perform its obligations due to unforeseen circumstances beyond its reasonable control, including but not limited to natural disasters, pandemics, or government actions.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">30. User Feedback Policy</h2>
            <p className="text-gray-600 mt-2">
              30.1. User feedback is valuable for improving our services. We may collect, use, and display user feedback in accordance with our Privacy Policy.
            </p>
            <p className="text-gray-600 mt-2">
              30.2. Users grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, and display any feedback provided.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">31. Governing Law</h2>
            <p className="text-gray-600 mt-2">
              31.1. These terms are governed by the laws of Ghana.
            </p>
            <p className="text-gray-600 mt-2">
              31.2. Any disputes will be resolved in the courts of app operation.
            </p>

            <p className="text-gray-600 mt-8 font-semibold">
              By using KOVA, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions; 